import { logUsage } from 'owa-analytics';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getTimeSuggestionsStore } from '../selectors/getTimeSuggestionsStore';
import getNumberOfTimeSuggestionsToDisplay from '../selectors/getNumberOfTimeSuggestionsToDisplay';

export default function logTimeSuggestionsRequestSummary(
    event: CalendarEvent,
    statusCode: number,
    timeSuggestionsCount: number,
    emptySuggestionsReason: string,
    viewStateId: string | null
) {
    const {
        timingSearchCriteria: urgency,
        durationSearchCriteria: duration,
    } = getTimeSuggestionsStore(viewStateId);
    let attendeeCount: number = event.RequiredAttendees?.length + event.OptionalAttendees?.length;
    logUsage('findTimeRequestSummary', {
        urgency: urgency,
        duration: duration,
        resultStatus: statusCode,
        attendeesCount: attendeeCount,
        resultReceivedCount: timeSuggestionsCount,
        resultsUsedCount: getNumberOfTimeSuggestionsToDisplay(viewStateId),
        emptySuggestionReason: emptySuggestionsReason,
    });
}
